import { useEffect, useRef, useContext } from 'react';
import { useDispatch } from 'react-redux';

import { pushEvent } from 'state/analytics/analytics-slice';
import { CardsContext } from 'components/direct-sales/select-options/contexts/CardContext';

type TrackedCtaProps = {
  children?: React.ReactNode;
  name?: string;
};

export const TrackedCta = ({ children, name }: TrackedCtaProps) => {
  const dispatch = useDispatch();
  const ctaRef = useRef<HTMLDivElement>(null);
  const { registerCard } = useContext(CardsContext);

  const trackCtaClick = (event) => {
    const analyticsEvent = {
      category: 'componentAction',
      action: 'click',
      label: `${name}:${event?.target?.textContent}`
    };

    dispatch(pushEvent(analyticsEvent));
  };

  useEffect(() => {
    registerCard(`${name}:${ctaRef?.current?.textContent}`);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={ctaRef} onClick={trackCtaClick}>
      {children}
    </div>
  );
};
